import { render, staticRenderFns } from "./InfoSetting.vue?vue&type=template&id=29a167c4&scoped=true"
import script from "./InfoSetting.vue?vue&type=script&lang=js"
export * from "./InfoSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a167c4",
  null
  
)

export default component.exports